import { useI18n } from '@/lib/i18n';
import { LOCALE_SHORT } from '@/lib/i18n/types';
import { cn } from '@/lib/utils';

/**
 * Language toggle for Canadian site (EN | FR)
 * Only renders on the Canadian domain
 */
export function LanguageToggle() {
  const { region, locale, setLocale, availableLocales } = useI18n();
  
  // Only show on Canadian site
  if (region !== 'CA') return null;
  
  return (
    <div className="flex items-center gap-1 text-sm">
      {availableLocales.map((loc, index) => (
        <span key={loc} className="flex items-center">
          {index > 0 && <span className="text-muted-foreground mx-1">|</span>}
          <button
            onClick={() => setLocale(loc)}
            className={cn(
              'font-medium transition-colors hover:text-primary',
              locale === loc ? 'text-primary' : 'text-muted-foreground'
            )}
            aria-label={`Switch to ${LOCALE_SHORT[loc]}`}
          >
            {LOCALE_SHORT[loc]}
          </button>
        </span>
      ))}
    </div>
  );
}

export default LanguageToggle;
